export default {"src":"/_next/static/media/shipping.bfd4cccc.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};